import React, { useEffect, useRef, useState } from 'react';
import {
	ChartWrapper,
	TitleSection,
	TopContentWrapper,
	Wrapper,
} from '../shared.styles';
import { getQueueLastWeekDownloadStats } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import SelectInput from '@/common/components/SelectInput';
import Input from '@/common/components/Input';
import { CONSULTANT_ROLES } from '@/pages/login/components/LoginForm/loginForm';
import CustomDoughnut from '@/common/charts/Doughnut';
import { COLORS_ARRAY } from '@/common/colors/colorsArray';
import Icon from '@/common/components/Icon';

const DonuteCallingStats = () => {
	const [chartData, setChartData] = useState();
	const [selectedMarket, setSelectedMarket] = useState();

	const {
		commonData: { users },
	} = useCommonDataContext();
	const timeRangeRef = useRef();

	const { makeRequest } = useRequestsContext();

	const handleLoadData = async () => {
		setChartData(() => null);
		const payload = {};
		payload.consultants = [selectedMarket.value];
		payload.timeFrom = timeRangeRef.current.value;

		const response = await makeRequest(
			getQueueLastWeekDownloadStats.bind(null, payload),
		);

		if (response.data) {
			const data = {
				labels: ['Shift', 'Confirm', 'Resign', 'Trash', 'No response'],
				downloaded: response.data.length,
				datasets: [
					{
						label: 'Daily grade',
						data: [
							response.data.filter((d) => d.status === 'shift')?.length,
							response.data.filter((d) => d.status === 'confirmed')?.length,
							response.data.filter((d) => d.status === 'resigned')?.length,
							response.data.filter((d) => d.status === 'trash')?.length,
							response.data.filter((d) => d.status === 'no_response')?.length,
						],
						backgroundColor: [
							COLORS_ARRAY[0],
							COLORS_ARRAY[1],
							COLORS_ARRAY[2],
							COLORS_ARRAY[3],
							COLORS_ARRAY[4],
							COLORS_ARRAY[5],
						],
						borderColor: [
							COLORS_ARRAY[0],
							COLORS_ARRAY[1],
							COLORS_ARRAY[2],
							COLORS_ARRAY[3],
							COLORS_ARRAY[4],
							COLORS_ARRAY[5],
						],
					},
				],
			};
			setChartData((prev) => data);
		}
	};

	useEffect(() => {
		if (users[0] && selectedMarket) {
			handleLoadData();
		}
	}, [users, selectedMarket]);

	useEffect(() => {
		if (users[0]) {
			setSelectedMarket(() => filterUsers(users)[0]);
		}
	}, [users]);

	const filterUsers = (users) =>
		users
			.filter((user) => user.active && CONSULTANT_ROLES.includes(user.role))
			.map((u) => ({ label: u.username, value: u._id }));

	return (
		<Wrapper width={800}>
			<TitleSection>
				<TopContentWrapper>
					<Icon name='usps' size={25} />
					Daily doughtnut ({chartData?.downloaded})
				</TopContentWrapper>
				<TopContentWrapper>
					<Input
						showLabel={false}
						inputWidth={50}
						value={0}
						inputRef={timeRangeRef}
					/>
					<SelectInput
						options={filterUsers(users)}
						selected={selectedMarket}
						setSelected={setSelectedMarket}
						selectWidth={200}
						showLabel={false}
					/>
					<Icon
						name='refresh'
						className='animation-scale'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>{' '}
				</TopContentWrapper>
			</TitleSection>
			<ChartWrapper style={{ justifyContent: 'center', height: '420px' }}>
				{chartData ? (
					<CustomDoughnut data={chartData} />
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export default DonuteCallingStats;
